<form class="mce-form-section">


    <div class="mce-form-field-group">

        @if(!isBuried()) {
        <div>
            <mat-form-field>
                <mat-label>air temperature</mat-label>
                <input matInput type="number" placeholder="air temperature"
                       [formField]="form().airTemperature" />
                <span matSuffix>°C</span>
                @for (error of form().airTemperature().errors(); track error.kind ) {
                <mat-error> {{ error.message }} </mat-error> }
            </mat-form-field>
        </div>
        }

        @if(isBuried()) {
        <div>
            <mat-form-field>
                <mat-label>ground temperature</mat-label>
                <input matInput type="number" placeholder="ground temperature"
                       [formField]="form().groundTemperature" />
                <span matSuffix>°C</span>
                @for (error of form().groundTemperature().errors(); track error.kind ) {
                <mat-error> {{ error.message }} </mat-error> }
            </mat-form-field>
        </div>
        }


    </div>

</form>
